import { FC, forwardRef, Ref } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

export interface LinkWithQueryProps extends LinkProps {}

const LinkWithQuery: FC<LinkWithQueryProps> = forwardRef(
  ({ to, ...props }, ref) => {
    const { search } = useLocation();
    return (
      <Link to={to + search} ref={ref as Ref<HTMLAnchorElement>} {...props} />
    );
  }
);

export default LinkWithQuery;
